import { AnimatePresence, motion } from "framer-motion";
import { Lock } from "lucide-react";
import { SocialPortraitCard } from "../SocialPortraitCard";
import { aiRecommendation as rec } from "../../data/phase2Content";
import { useDemo } from "../../context/DemoContext";

export const AIRecommendationCard = ({ consent }) => {
  const { setPreview } = useDemo();
  const view = () => setPreview(rec.preview);
  return (
    <AnimatePresence mode="wait" initial={false}>
      {consent ? (
        <motion.div key="rec" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 16 }} transition={{ duration: 0.35 }} data-testid="ai-recommendation">
          <p className="text-[13px] font-semibold text-[#7866E8]">{rec.forWho}</p>
          <p className="mb-4 mt-1 text-[19px] font-bold leading-snug tracking-[-0.02em] text-[#08090D]" data-testid="ai-recommendation-headline">{rec.headline}</p>
          <SocialPortraitCard item={rec} radius={32} testId="ai-recommendation-card" onOpen={view} onCta={view} />
          <p className="mt-4 text-[13.5px] leading-relaxed text-[#4c5064]" data-testid="ai-recommendation-reason">{rec.reason}</p>
        </motion.div>
      ) : (
        <motion.div
          key="withdrawn"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.35 }}
          data-testid="ai-recommendation-withdrawn"
          role="status"
          className="glass glass-light rounded-[32px] p-6"
        >
          <span className="grid h-11 w-11 place-items-center rounded-full bg-[#08090D] text-white"><Lock size={18} aria-hidden /></span>
          <p className="mt-4 text-[20px] font-bold tracking-[-0.02em] text-[#08090D]">Suggestion withdrawn</p>
          <p className="mt-2 text-[15px] leading-relaxed text-[#3c4052]">{rec.withdrawn}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
